import { apiWrapperNoToken, apiWrapper } from '../helper/api-wrapper';

export const getProvinces = async () => {
  try {
    const response = await apiWrapperNoToken.get('merchants/cms/state/region');

    return response;
  } catch (error) {
    throw error;
  }
};

export const getCities = async (provinceId) => {
  try {
    const response = await apiWrapperNoToken.get(
      `merchants/cms/state/district/${provinceId}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDistrict = async (cityId) => {
  try {
    const response = await apiWrapperNoToken.get(
      `merchants/cms/state/township/${cityId}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getSubdistrict = async (districtId) => {
  try {
    const response = await apiWrapperNoToken.get(
      `merchants/cms/state/village/${districtId}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getRoomType = async () => {
  try {
    const response = await apiWrapper.get(`merchants/room_type`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getCategory = async () => {
  try {
    const response = await apiWrapper.get(`merchant/cms/list_category_v2`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getSubCategory = async (categoryId) => {
  try {
    const response = await apiWrapper.get(
      `merchant/cms/list_subcategory_v2/${categoryId}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getSubSubCategory = async (subCategoryId) => {
  try {
    const response = await apiWrapper.get(
      `merchant/cms/list_sub_subcategory_v2/${subCategoryId}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getTimeSlotList = async () => {
  try {
    const response = await apiWrapper.get(`shipper/order/timeslot/jakarta`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getVendorBrand = async () => {
  try {
    const response = await apiWrapper.get(`merchants/brand/list`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getVendorBrandList = async () => {
  try {
    const response = await apiWrapper.get(`merchants/brand/dropdown/list`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getFeedbackList = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchant/express_package/feedback/history/${payload?.id}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getDialogChatList = async () => {
  try {
    const response = await apiWrapper.post(`merchants/chat/dialog/get`);

    return response;
  } catch (error) {
    throw error;
  }
};

export const getListFaq = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/cms/faqByType/merchant`,
      payload
    );

    return response;
  } catch (error) {
    throw error;
  }
};
// export const getKecamatan = async (id) => {
//   try {
//     const response = await apiWrapperNoToken.get(`users/cms/state/city/${id}`);

//     return response;
//   } catch (error) {
//     throw error;
//   }
// };

// async function getKelurahan(id) {
//   var req = await apiWrapper.getNoToken('users/cms/state/village/' + id);
//   const res = await req.json();
//   return res;
// }
